"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.Spinner = native_1.default.ActivityIndicator `
  color: ${({ theme, color }) => color || theme.bpCore.colors.primary[500]};
  width: 0;
  height: 100%;
  z-index: 999;
  position: absolute;
  align-items: center;
  flex: 1;
  justify-content: center;
`;
